import { useIsMounted } from ".";
import { useEffect, useState } from "react";
import { useAppContext } from "contexts";
import { database } from "configs/firebaseConfigs";
import { onValue, ref } from "firebase/database";
import { getArrFromObj, getArrFromSnap } from "@ashirbad/js-core";

const useDataFetch = (path) => {
  const isMounted = useIsMounted();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isMounted?.current) {
      const fetchData = async () => {
        try {
          onValue(ref(database, `${path}`), (snapshot) => {
            if (snapshot.exists()) {
              let dbData = getArrFromSnap(snapshot);
              let newData = dbData?.map((_, i) => ({ ..._, sl: i + 1 }));
              setData(newData);
              setLoading(false);
            } else {
              setData(null);
              setLoading(false);
            }
          });
        } catch (error) {
          setError(error);
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [path, isMounted]);

  return { data, loading, error };
};

const useProducts = () => {
  const { data, loading, error } = useDataFetch("/products");
  return { data, loading, error };
};
const useFeaturedProduct = () => {
  const [featuredData, setFeaturedData] = useState([]);
  const productData = useDataFetch("/products");
  const isMounted = useIsMounted();
  useEffect(() => {
    if (isMounted.current) {
      let filteredData = productData?.data?.filter(
        (item) => item.featured === true
      );

      setFeaturedData(filteredData || []);
    }
  }, [productData?.data, isMounted]);

  return {
    data: featuredData,
    loading: productData?.loading,
    error: productData?.error,
  };
};
const useUsers = () => {
  const { data, loading, error } = useDataFetch("/users");
  return { data, loading, error };
};
const useSuppliers = () => {
  const { data, loading, error } = useDataFetch("/suppliers");
  return { data, loading, error };
};
const useCartData = () => {
  const { user } = useAppContext();
  const { data, loading, error } = useDataFetch(`/cart/${user?.uid}`);
  return { data, loading, error };
};
const useWishlistData = () => {
  const { user } = useAppContext();
  const { data, loading, error } = useDataFetch(`/wishlist/${user?.uid}`);
  return { data, loading, error };
};
const useMessages = () => {
  const { data, loading, error } = useDataFetch(`/contactus`);
  return { data, loading, error };
};
const useOrdersData = () => {
  const isMounted = useIsMounted();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isMounted?.current) {
      const fetchData = async () => {
        try {
          onValue(ref(database, `/orders`), (snapshot) => {
            if (snapshot.exists()) {
              const receiveData = Object.values(snapshot.val());

              let dbData = [];
              let i = 1;

              receiveData?.map((item, index) => {
                let newItem = getArrFromObj(item);
                newItem.map((_, index) => {
                  dbData.push({ ..._, sl: i });
                  i++;
                  return _;
                });
                return newItem;
              });
              if (dbData.length > 0) {
                setData(dbData);
              }

              setLoading(false);
            } else {
              setData(null);
              setLoading(false);
            }
          });
        } catch (error) {
          setError(error);
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [isMounted]);

  return { data, loading, error };
};

export {
  useProducts,
  useCartData,
  useWishlistData,
  useSuppliers,
  useUsers,
  useOrdersData,
  useFeaturedProduct,
  useMessages,
};
export default useDataFetch;
